import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=6fc82419&scoped=true&lang=html&"
import script from "./AboutHero.vue?vue&type=script&lang=js&"
export * from "./AboutHero.vue?vue&type=script&lang=js&"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=6fc82419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc82419",
  null
  
)

export default component.exports